var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":800},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[(_vm.val)?_c('div',[_c('h2',{staticClass:"mb-m"},[_vm._v("消費者網路投保需求聲明事項(KYC)")]),_c('ol',{style:({
          paddingLeft: '15px',
          fontSize: '14px',
          color: '#5D5E60'
        })},_vm._l((_vm.items),function(item){return _c('li',{key:item,style:({lineHeight: '1.8'}),domProps:{"textContent":_vm._s(item)}})}),0)]):_vm._e(),_c('div',{attrs:{"slot":"footer"},slot:"footer"})])}
var staticRenderFns = []

export { render, staticRenderFns }